import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import "./ui.css";

// One message at a time at the bottom of the screen, with an optional action
// (usually "Undo"). Hides itself after a few seconds.
export default function Toast({ toast, onDone }) {
  useEffect(() => {
    if (!toast) return undefined;
    const t = setTimeout(onDone, toast.action ? 7000 : 4000);
    return () => clearTimeout(t);
  }, [toast, onDone]);

  if (!toast) return null;

  return createPortal(
    <div className="toast" role="status">
      <span>{toast.message}</span>
      {toast.action && (
        <button
          type="button"
          onClick={() => {
            toast.action.run();
            onDone();
          }}
        >
          {toast.action.label}
        </button>
      )}
    </div>,
    document.body
  );
}
